import React from 'react';
import QuadProd from './QuadProd';
import { TesesDB } from '../TesesDB';

function Thesis() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Teses</h2>
                    
                    {
                    TesesDB.map((user, i) => {
                    return (
                        <QuadProd  
                        key={i} 
                        titulo={TesesDB[i].titulo} 
                        meio={TesesDB[i].meio}
                        link={TesesDB[i].link} 
                        data={TesesDB[i].data} 
                        text1={TesesDB[i].text1} 
                        text2={TesesDB[i].text2} 
                        icon={TesesDB[i].icon}
                        status={TesesDB[i].status}
                        />
                        );
                    })
                  }
                </div>
              </div>
    </section>
    

  );
}

export default Thesis;